module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flyCont",
    staticStyle: {
      "height": "380px"
    }
  }, _vm._l((_vm.fireFlys), function(fly) {
    return _c('span', {
      staticClass: "fly",
      style: ({
        width: fly.w + 'px',
        height: fly.w + 'px',
        top: fly.posTop + 'px',
        left: fly.posLeft + 'px'
      })
    })
  }))
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-75d7cbca", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-75d7cbca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/Firefly.vue
// module id = 50
// module chunks = 1